import React, { memo } from 'react'

import TourV2FinePrintSection from './TourV2FinePrintSection'

interface Props {
  finePrint: Tours.V2OfferFinePrint
}

function TourV2FinePrint(props: Props) {
  const { finePrint } = props

  return <>
    {finePrint.sections.map((finePrintSection, index) => (
      <TourV2FinePrintSection key={index} finePrintSection={finePrintSection} />
    ))}
  </>
}

export default memo(TourV2FinePrint)
